import { useContent } from "../../i18n";
import { BrandDemo } from "../Demos/BrandDemo";
import { ClaimDemo } from "../Demos/ClaimDemo";
import "../Providers/style.scss";
import "./style.scss";

export const Organizations = () => {
  const { organizations, demos } = useContent();

  return (
    <div id="organizations" className="organizations-wrapper">
      <div className="container">
        <h2>{organizations.title}</h2>
        <p className="section-intro">{organizations.intro}</p>

        <div className="info-grid two">
          {organizations.audiences.map((item) => (
            <div className="info-card" key={item.t}>
              <h4>{item.t}</h4>
              <p>{item.d}</p>
            </div>
          ))}
        </div>

        <h3 className="sub-title">{demos.claim.title}</h3>
        <p className="sub-intro">{demos.claim.intro}</p>
        <ClaimDemo />

        <h3 className="sub-title">{organizations.modesTitle}</h3>
        <div className="info-grid two">
          {organizations.modes.map((item) => (
            <div className="info-card model" key={item.t}>
              <h4>{item.t}</h4>
              <p>{item.d}</p>
            </div>
          ))}
        </div>

        <h3 className="sub-title">{demos.brand.title}</h3>
        <p className="sub-intro">{demos.brand.intro}</p>
        <BrandDemo />

        <div className="with-you">
          <h3>{organizations.withYouTitle}</h3>
          <p>{organizations.withYouIntro}</p>
          <ul>
            {organizations.withYou.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>

        <p className="journey-link">
          <a href="/meeting.html">{organizations.meetingLink}</a>
        </p>

        <div className="section-cta">
          <a className="cta-button" href="#contact">
            {organizations.cta}
          </a>
        </div>
      </div>
    </div>
  );
};
